import type { ILayerProps, ISize } from '@/version-types';
import type { BlockDirectionType, BlockInfo } from '../types';
import LayerBlock from './layer-block';

/** 按图层 ID 保存一次吸附准备阶段产生的等间距块索引。 */
export class BlockList {
    /** 当前准备阶段的图层块索引。 */
    private data: Map<string, LayerBlock>;

    constructor() {
        this.data = new Map();
    }

    push(layer: ILayerProps, layers: ILayerProps[], activeLayer: ILayerProps, container: ISize) {
        const block = new LayerBlock(layer.id).collectBlocks(layer, layers, activeLayer, container);
        this.data.set(block.id, block);
    }

    getBlocks(id: string, spacing: number, direction: BlockDirectionType) {
        const res: BlockInfo[] = [];
        const collectInfo = (id: string) => {
            const info = this.data.get(id);
            if (!info) return;
            const blocks = info.getBlocksWithSpacing(spacing, direction);
            if (!blocks) return;
            res.push(...blocks);
            blocks.forEach((item) => {
                collectInfo(item.id);
            });
        };
        collectInfo(id);
        return res;
    }

    forEach(callback: (item: LayerBlock) => void) {
        this.data.forEach((val) => {
            callback(val);
        });
    }
}

export default BlockList;
